import * as GroupType from 'constants/GroupType';

const WATERPOLO_GROUP_MAP = {};

WATERPOLO_GROUP_MAP[0] = GroupType.DEFAULT_GROUP;
WATERPOLO_GROUP_MAP[1] = GroupType.FIRST_PERIOD_GROUP;
WATERPOLO_GROUP_MAP[2] = GroupType.SECOND_PERIOD_GROUP;
WATERPOLO_GROUP_MAP[3] = GroupType.THIRD_PERIOD_GROUP;
WATERPOLO_GROUP_MAP[4] = GroupType.FOURTH_PERIOD_GROUP;

export default WATERPOLO_GROUP_MAP;


// WEBPACK FOOTER //
// ./js/sport-betting/components/grid-control/sportGlossary/Waterpolo/GroupMap.js